import * as d3 from "d3";
function drawLegend(chart, legendData, innerHeight) {
    if (legendData.length > 0) {
        const baseSpacing = 20; // Base spacing between items
        const verticalOffset = innerHeight + 40;
        const legend = chart.append("g").attr("class", "legend").attr("transform", `translate(0, ${verticalOffset})`);
        // First, create the legend items without positioning them horizontally
        const legendItem = legend.selectAll(".legend-item").data(legendData).enter().append("g").attr("class", "legend-item");
        legendItem.append("rect").attr("x", 0).attr("y", 0).attr("width", 10).attr("height", 10).attr("fill", (d)=>d.color).attr("opacity", 0.4);
        legendItem.append("text").attr("x", 15).attr("y", 10).attr("fill", "#68677C").attr("font-family", "Aeonik Light").attr("class", (d)=>d.classes ?? "font-light text-xs").style("text-anchor", "start").text((d)=>d.label);
        // After the items are created, measure and reposition them
        let cumulativeX = 0;
        legendItem.each(function() {
            // Measure each legend item
            const node = d3.select(this).node();
            const { width } = node.getBBox();
            // Position the current item
            d3.select(this).attr("transform", `translate(${cumulativeX}, 0)`);
            // Increase the cumulative offset by this item's width plus spacing
            cumulativeX += width + baseSpacing;
        });
    }
}
export { drawLegend };
